import React, { useState, useEffect } from "react";
import axios from 'axios';
import './../styles/default.css';
import './../styles/quiero_trabajar.css';
import Logo from './../components/logo_black.png'
import * as globals from './../components/GlobalScripts.js';
import { Link, useNavigate } from 'react-router-dom';

import banner1 from './../components/quiero_trabajar/banner1.jpg';

const Login = () => {
    let path_api = localStorage.getItem('path_api');
    const navigate = useNavigate();
    const [categoriasOptions, setCategoriasOptions] = useState([]);
    const [estadosCiudades, setEstadosCiudades] = useState([]);
    const [step, setStep] = useState(1);
    const [resendTimer, setResendTimer] = useState(0);
    const [formDataAccount, setFormDataAccount] = useState({});
    const [formDataVerify, setFormDataVerify] = useState({});
    const [formDataAddress, setFormDataAddress] = useState({});
    const [formDataProfile, setFormDataProfile] = useState({
        profesion: 'Mudanzas',
        descripcion: '',
        estado: "Aguascalientes",
        ciudad: "Aguascalientes",
    });

    useEffect(() => {
        get_categorias();
        get_estados_ciudades();
    }, []);

    const get_estados_ciudades = () => {
        axios.post(`${path_api}/default/get_estados_ciudades.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setEstadosCiudades(response.data.estados);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se cargaron los estados y ciudades",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar estados y ciudades",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });
    };

    const get_categorias = () => {
        axios.post(`${path_api}/default/get_categorias.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setCategoriasOptions(response.data.categorias);
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "No se cargaron las categorias", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al cargar las categorias", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
    };

    const send_mail_code = () => {
        axios.post(`${path_api}/create-account/code_send_mail.php`, {
            rute: globals.getRuteBackend(),
            nombre: formDataAccount.nombre,
            email: formDataAccount.email
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Enviado",
                    msg: "El correo se envió con éxito",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                setResendTimer(60);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se realizó el envío del correo",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "No se realizó el envío del correo",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });
    };

    const validateCode = () => {
        axios.post(`${path_api}/create-account/validate_code.php`, {
            rute: globals.getRuteBackend(),
            code: formDataVerify.code
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Código Validado",
                    msg: "El código es correcto.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                setStep(3);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "El código no es válido",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al validar el código",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });
    };

    useEffect(() => {
        let interval;
        if (step === 2 && resendTimer > 0) {
            interval = setInterval(() => {
                setResendTimer(prev => (prev > 0 ? prev - 1 : 0));
            }, 1000);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [step, resendTimer]);

    const handleResend = () => {
        if (resendTimer === 0) {
            send_mail_code();
        }
    };

    const handleSubmit_account = async (e) => {
        e.preventDefault();
        send_mail_code();
        setStep(2);
    };

    const handleSubmit_verify = async (e) => {
        e.preventDefault();
        validateCode();
    };

    const handleSubmit_address = async (e) => {
        e.preventDefault();
        setStep(4);
    };

    const handleSubmit_profile = async (e) => {
        e.preventDefault();
        axios.post(`${path_api}/create-account/create-profesional.php`, {
            rute: globals.getRuteBackend(),
            account: formDataAccount,
            address: formDataAddress,
            prof: formDataProfile,
        }).then(response => {
            if (response.data.mensaje === 'success') {
                globals.createAlert({
                    type: "success",
                    msg_title: "Éxito",
                    msg: "Tu cuenta se creó sin problemas.",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
                localStorage.setItem('session_id', response.data.session_id);
                localStorage.setItem('keylogin', response.data.keylogin);
                localStorage.setItem('user', JSON.stringify(response.data.user));
                localStorage.setItem('code_confirm', '1');
                navigate(`/profesional/perfil`);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "Tu cuenta no se ha creado",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al crear la cuenta",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });
    };

    const handleChange_account = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setFormDataAccount({ ...formDataAccount, [name]: newValue });
    };

    const handleChange_verify = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setFormDataVerify({ ...formDataVerify, [name]: newValue });
    };

    const handleChange_address = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setFormDataAddress({ ...formDataAddress, [name]: newValue });
    };

    const handleChange_profile = (e) => {
        const { name, type, checked, value } = e.target;
        const newValue = type === "checkbox" ? checked : value;
        setFormDataProfile({ ...formDataProfile, [name]: newValue });
    };

    return (
        <>
            <div className="app-default app-container">
                <div className="main-content page-quiero-trabajar">
                    <div className="page-container">
                        <div className="section-capture-data">
                            <div className="banner" style={{ backgroundImage: `url(${banner1})` }}></div>
                            <div className="capture-data">
                                <Link to="/">
                                    <img src={Logo} className="logo"></img>
                                </Link>
                                <div>
                                    {step == 1 && (
                                        <form onSubmit={handleSubmit_account} className="flex-column gap-20">
                                            <Link to="/" className="flex-row gap-5">
                                                <svg width="20" viewBox="0 0 100 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M24.163 41.125L38.7085 55.6658L38.7088 55.6662C39.2779 56.2353 39.7294 56.9109 40.0374 57.6545C40.3454 58.3981 40.5039 59.1951 40.5039 60C40.5039 60.8049 40.3454 61.6018 40.0374 62.3454C39.7294 63.089 39.2779 63.7647 38.7088 64.3338C38.1397 64.9029 37.464 65.3544 36.7204 65.6624C35.9768 65.9704 35.1798 66.1289 34.375 66.1289C33.5701 66.1289 32.7732 65.9704 32.0296 65.6624C31.2859 65.3544 30.6103 64.9029 30.0412 64.3338L5.04386 39.3365C5.04297 39.3356 5.04207 39.3347 5.04118 39.3338M24.163 41.125L36.5875 12.2125C36.878 11.9219 37.1085 11.577 37.2658 11.1974C37.423 10.8178 37.5039 10.4109 37.5039 10C37.5039 9.5891 37.423 9.18222 37.2658 8.8026C37.1085 8.42298 36.878 8.07805 36.5875 7.7875C36.2969 7.49695 35.952 7.26647 35.5724 7.10923C35.1928 6.95198 34.7859 6.87105 34.375 6.87105C33.9641 6.87105 33.5572 6.95198 33.1776 7.10923C32.798 7.26647 32.453 7.49695 32.1625 7.7875L7.1625 32.7875C6.87148 33.0778 6.64059 33.4226 6.48305 33.8023C6.32551 34.1819 6.24441 34.589 6.24441 35C6.24441 35.411 6.32551 35.818 6.48305 36.1977C6.64059 36.5774 6.87148 36.9222 7.1625 37.2125L5.04118 39.3338M24.163 41.125H90.625C92.2494 41.125 93.8074 40.4797 94.956 39.331C96.1047 38.1824 96.75 36.6244 96.75 35C96.75 33.3755 96.1047 31.8176 94.956 30.669C93.8074 29.5203 92.2495 28.875 90.625 28.875H24.163L38.7085 14.3342L38.7088 14.3338C39.2779 13.7647 39.7294 13.089 40.0374 12.3454C40.3454 11.6018 40.5039 10.8049 40.5039 10C40.5039 9.19513 40.3454 8.39815 40.0374 7.65455C39.7294 6.91095 39.2779 6.2353 38.7088 5.66618C38.1397 5.09705 37.464 4.6456 36.7204 4.33759C35.9768 4.02958 35.1799 3.87105 34.375 3.87105C33.5701 3.87105 32.7731 4.02958 32.0296 4.33759C31.286 4.6456 30.6103 5.09705 30.0412 5.66618L5.04386 30.6635L7.16215 32.7871L5.04118 30.6662M24.163 41.125L5.04118 30.6662M5.04118 39.3338C4.47204 38.7654 4.02043 38.0905 3.71213 37.3475C3.40336 36.6034 3.24441 35.8056 3.24441 35C3.24441 34.1943 3.40336 33.3966 3.71213 32.6525C4.02043 31.9095 4.47204 31.2346 5.04118 30.6662M5.04118 39.3338L5.04118 30.6662" fill="var(--color-primary)" stroke="var(--color-primary)" stroke-width="6"/>
                                                </svg>
                                                <h4 style={{color: "var(--color-primary)"}}>Volver a inicio</h4>
                                            </Link>
                                            <h2>Registrate</h2>
                                            <h5>¿Ya tienes una cuenta? <Link to="/login">Inicia sesión</Link></h5>
                                            <div className="form-grop-row">
                                                <div className="form-group">
                                                    <label htmlFor="nombre">Nombre(s)</label>
                                                    <input
                                                        type="text"
                                                        id="nombre"
                                                        name="nombre"
                                                        value={formDataAccount.nombre}
                                                        onChange={handleChange_account}
                                                        className="input-primary"
                                                        placeholder="nombre"
                                                        required
                                                    />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="apellidos">Apellidos</label>
                                                    <input
                                                        type="text"
                                                        id="apellidos"
                                                        name="apellidos"
                                                        value={formDataAccount.apellidos}
                                                        onChange={handleChange_account}
                                                        className="input-primary"
                                                        placeholder="apellidos"
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="email">Email</label>
                                                <input
                                                    type="email"
                                                    id="email"
                                                    name="email"
                                                    value={formDataAccount.email}
                                                    onChange={handleChange_account}
                                                    className="input-primary"
                                                    placeholder="ejemplo@ejemplo.com"
                                                    required
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="phone">Telefono</label>
                                                <input
                                                    type="tel"
                                                    id="phone"
                                                    name="phone"
                                                    value={formDataAccount.phone}
                                                    onChange={handleChange_account}
                                                    className="input-primary"
                                                    placeholder="--- --- ----"
                                                    required
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="terms">
                                                    <input
                                                        type="checkbox"
                                                        id="terms"
                                                        name="terms"
                                                        checked={formDataAccount.terms}
                                                        onChange={handleChange_account}
                                                        className="input-primary"
                                                        required
                                                    />
                                                    Acepto los <a href="/terminos-condiciones" target="_blank" rel="noopener noreferrer">Términos y Condiciones</a>
                                                </label>
                                            </div>


                                            <button className="button-primary" type="submit">Siguiente</button>
                                        </form>
                                    )}
                                    {step == 2 && (
                                        <form onSubmit={handleSubmit_verify} className="flex-column gap-20">
                                            <h2>Verificación</h2>
                                            <h5>Se envio un codigo al correo <b>{formDataAccount.email}</b> para verificar que es una dirección valida.</h5>
                                            <div className="form-group">
                                                <label htmlFor="code">Codigo</label>
                                                <input
                                                    type="text"
                                                    id="code"
                                                    name="code"
                                                    value={formDataVerify.code}
                                                    onChange={handleChange_verify}
                                                    className="input-primary"
                                                    placeholder="Código de 6 digitos"
                                                    required
                                                />
                                                {resendTimer > 0 ? (
                                                    <p>Reenviar en {resendTimer} segundos</p>
                                                ) : (
                                                    <p className="cursor-pointer" onClick={handleResend}><u>Reenviar correo</u></p>
                                                )}
                                            </div>

                                            <button className="button-primary" type="submit">Verificar</button>
                                        </form>
                                    )}
                                    {step == 3 && (
                                        <form onSubmit={handleSubmit_address} className="flex-column gap-20">
                                            <h2>Hola, {formDataAccount.nombre}</h2>
                                            <h5>Se creará una cuenta bajo el correo <b>{formDataAccount.email}</b> al finalizar de llenar los datos.</h5>

                                            <div className="form-group">
                                                <label htmlFor="direccion">Dirección</label>
                                                <input
                                                    type="text"
                                                    id="direccion"
                                                    name="direccion"
                                                    value={formDataAddress.direccion}
                                                    onChange={handleChange_address}
                                                    className="input-primary"
                                                    placeholder="roma #123"
                                                    required
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="referencia">Referencia</label>
                                                <input
                                                    type="text"
                                                    id="referencia"
                                                    name="referencia"
                                                    value={formDataAddress.referencia}
                                                    onChange={handleChange_address}
                                                    className="input-primary"
                                                    placeholder=""
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="apartamento">Apartamento</label>
                                                <input
                                                    type="text"
                                                    id="apartamento"
                                                    name="apartamento"
                                                    value={formDataAddress.apartamento}
                                                    onChange={handleChange_address}
                                                    className="input-primary"
                                                    placeholder=""
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="estado">Estado</label>
                                                <select
                                                    id="estado"
                                                    name="estado"
                                                    value={formDataAddress.estado}
                                                    onChange={handleChange_address}
                                                    className="input-primary"
                                                    required
                                                >
                                                    <option value="">Selecciona un estado</option>
                                                    {estadosCiudades.map((item, index) => (
                                                        <option key={index} value={item.nombre}>
                                                            {item.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="ciudad">Ciudad</label>
                                                <select
                                                    id="ciudad"
                                                    name="ciudad"
                                                    value={formDataAddress.ciudad}
                                                    onChange={handleChange_address}
                                                    className="input-primary"
                                                    required
                                                >
                                                    <option value="">Selecciona una ciudad</option>
                                                    {(() => {
                                                        const selectedState = estadosCiudades.find(
                                                            (item) => item.nombre === formDataAddress.estado
                                                        );
                                                        return selectedState && selectedState.ciudades
                                                            ? selectedState.ciudades.map((ciudad) => (
                                                                <option key={ciudad.id} value={ciudad.nombre}>
                                                                    {ciudad.nombre}
                                                                </option>
                                                            ))
                                                            : null;
                                                    })()}
                                                </select>
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="colonia">Colonia</label>
                                                <input
                                                    type="text"
                                                    id="colonia"
                                                    name="colonia"
                                                    value={formDataAddress.colonia}
                                                    onChange={handleChange_address}
                                                    className="input-primary"
                                                    placeholder=""
                                                    required
                                                />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="cp">Código postal</label>
                                                <input
                                                    type="number"
                                                    id="cp"
                                                    name="cp"
                                                    value={formDataAddress.cp}
                                                    onChange={handleChange_address}
                                                    className="input-primary"
                                                    placeholder=""
                                                    required
                                                />
                                            </div>

                                            <button className="button-primary" type="submit">Siguiente</button>
                                        </form>
                                    )}
                                    {step == 4 && (
                                        <form onSubmit={handleSubmit_profile} className="flex-column gap-20">
                                            <h2>Ya casi terminamos...</h2>
                                            <h5>Completa la información de tu perfil profesional, esto ayudá en las busquedas.</h5>
                                            <div className="form-group">
                                                <label htmlFor="profesion">Profesión</label>
                                                <select
                                                    id="profesion"
                                                    name="profesion"
                                                    value={formDataProfile.profesion}
                                                    onChange={handleChange_profile}
                                                    className="input-primary"
                                                    required
                                                >
                                                    {categoriasOptions.map((categoria, index) => (
                                                        <option key={index} value={categoria}>
                                                            {categoria}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="descripcion">Describe brevemente los trabajos que realizas</label>
                                                <textarea
                                                    id="descripcion"
                                                    name="descripcion"
                                                    value={formDataProfile.descripcion}
                                                    onChange={handleChange_profile}
                                                    className="input-primary"
                                                    placeholder="Ej. Reparación y Servicio de Lavadoras y refrigeradores de todas las marcas."
                                                    rows="4"
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="estado">Estado donde realizas tu servicio</label>
                                                <select
                                                    id="estado"
                                                    name="estado"
                                                    value={formDataProfile.estado}
                                                    onChange={handleChange_profile}
                                                    className="input-primary"
                                                    required
                                                >
                                                    <option value="todo el pais">todo el pais</option>
                                                    {estadosCiudades.map((item, index) => (
                                                        <option key={index} value={item.nombre}>
                                                            {item.nombre}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="ciudad">Ciudad donde realizas tu servicio</label>
                                                <select
                                                    id="ciudad"
                                                    name="ciudad"
                                                    value={formDataProfile.ciudad}
                                                    onChange={handleChange_profile}
                                                    className="input-primary"
                                                    required
                                                >
                                                    <option value="todo el estado">todo el estado</option>
                                                    {(() => {
                                                        const selectedState = estadosCiudades.find(
                                                            (item) => item.nombre === formDataProfile.estado
                                                        );
                                                        return selectedState && selectedState.ciudades
                                                            ? selectedState.ciudades.map((ciudad) => (
                                                                <option key={ciudad.id} value={ciudad.nombre}>
                                                                    {ciudad.nombre}
                                                                </option>
                                                            ))
                                                            : null;
                                                    })()}
                                                </select>
                                            </div>
                                            <button className="button-primary" type="submit">Crear cuenta</button>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Login;